import HeadCloseButton from './HeadCloseButton.jsx'

const Head = function({title, closeButton}) {
  return(
    <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
      <h3 className="text-xl font-semibold text-gray-900">
          {title}
      </h3>

      {typeof closeButton !== "undefined" && <HeadCloseButton onClick={closeButton.onClick}/>}
    </div>
  )
}

export default Head
